export const RULE_STATE = {
  READY_TO_SHOW: 'readyToShow',
  IGNORED: 'ignored',
  FIXED: 'fixed',
};

export const RULE_TRIGGERED_POSTFIX = 'RuleTriggered';
